import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSubscription } from "./SubscriptionContext";

const SubscriptionRoute = () => {
    const { hasAccess } = useSubscription();

    if (hasAccess === null) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                background: '#0a0a2e',
                gap: '2vh'
            }}>
                <div style={{
                    width: '4vh',
                    height: '4vh',
                    border: '0.3vh solid rgba(255, 255, 255, 0.1)',
                    borderTopColor: '#48CDFF',
                    borderRadius: '50%',
                    animation: 'subscription-spin 0.8s linear infinite'
                }} />
                <span style={{ fontSize: '2vh', color: 'rgba(255, 255, 255, 0.4)' }}>
                    Checking subscription...
                </span>
            </div>
        );
    }

    if (!hasAccess) {
        return <Navigate to="/settings/subscription" replace />;
    }

    return <Outlet />;
};

export default SubscriptionRoute;
